<template>
  <div class="uk-background-primary uk-container uk-container-large uk-background-primary tm-navbar-container">
    <ul class="uk-navbar-nav">
        <li v-for="ShopItemRelatedType in ShopItemRelatedTypes"
             v-if="RelatedShopItems[ShopItemRelatedType.id]"
             :key="ShopItemRelatedType.id"
             >
          <a class="h-min-auto" :href="`#related-type-${ShopItemRelatedType.id}`">{{ ShopItemRelatedType.name }}</a>
        </li>
    </ul>
  </div>
</template>
<script>
    import ShopItemBlock from "../ShopGroup/ShopItemBlock";

    export default {
        components: {ShopItemBlock},
        props: {
            ShopItemRelatedTypes: {
                type: Array,
                default() {
                    return []
                }
            },
            RelatedShopItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            },

            ShopOrderItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            }
        },
        data(){
            return {
                page: {
                    ShopOrderItems: this.ShopOrderItems
                },
            }
        },
        methods:{
            buy(quantity, ShopItem) {
                this.loading = true;
                this.$http.put('/cart/buy', {
                    quantity: quantity,
                    shopItemId: ShopItem.id
                }).then(
                    (response) => {
                        this.page.ShopOrderItems = response.body.data.shopOrderItems;
                        this.loading = false;
                        this.$bus.$emit('update-navbar-cart');
                    }
                )

            },
        }
    }
</script>



// WEBPACK FOOTER //
// RelatedMenu.vue?4331fcb8